module.exports = __webpack_public_path__ + "static/img/background.96afb613.svg";